import { render, staticRenderFns } from "./ZonasGeograficas.vue?vue&type=template&id=7b16baaf&scoped=true&"
import script from "./ZonasGeograficas.vue?vue&type=script&lang=js&"
export * from "./ZonasGeograficas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16baaf",
  null
  
)

export default component.exports